var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import videojs from 'video.js';
import { observer } from 'mobx-react';
import { observable, makeObservable } from 'mobx';
import { css, StyleSheet } from 'aphrodite';
import bind from 'bind-decorator';
import { MediaBreakPointUp } from '../../styles';
class VideoControllerComponent extends React.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "isPaused", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isShowing", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        // コントローラーの非表示切り替えを管理する
        Object.defineProperty(this, "timerId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        makeObservable(this, {
            isPaused: observable,
            isShowing: observable,
        });
    }
    setIsPaused(paused) {
        this.isPaused = paused;
    }
    setIsShowing(showing) {
        this.isShowing = showing;
        if (showing) {
            this.props.showProgressBar();
        }
        else {
            this.props.hideProgressBar();
        }
    }
    componentWillUnmount() {
        this.clearHideTimer();
    }
    handleSeekedEvent() {
        this.setHideTimer();
    }
    onPlayClick(e) {
        e.stopPropagation();
        e.preventDefault();
        this.setIsPaused(false);
        this.props.play();
        this.setHideTimer();
    }
    onPauseClick(e) {
        e.stopPropagation();
        e.preventDefault();
        this.setIsPaused(true);
        this.props.pause();
        this.setHideTimer();
    }
    onRewindClick(e) {
        e.stopPropagation();
        e.preventDefault();
        this.props.rewind();
        this.setHideTimer();
    }
    onForwardClick(e) {
        e.stopPropagation();
        e.preventDefault();
        this.props.forward();
        this.setHideTimer();
    }
    onPrevClick(e) {
        e.stopPropagation();
        e.preventDefault();
        this.clearHideTimer();
        this.props.prev();
    }
    onNextClick(e) {
        e.stopPropagation();
        e.preventDefault();
        this.clearHideTimer();
        this.props.next();
    }
    onOverlayClick(e) {
        e.stopPropagation();
        e.preventDefault();
        if (this.isShowing) {
            this.setIsShowing(false);
        }
        else {
            this.setIsShowing(true);
            this.setHideTimer();
        }
    }
    setHideTimer() {
        this.clearHideTimer();
        this.timerId = window.setTimeout(() => this.setIsShowing(false), 3000);
    }
    clearHideTimer() {
        if (this.timerId) {
            clearTimeout(this.timerId);
        }
    }
    show() {
        this.setIsShowing(true);
    }
    hide() {
        this.setIsShowing(false);
    }
    render() {
        if (!this.isShowing) {
            return React.createElement("div", { onClick: this.onOverlayClick, className: css(styles.overlay) });
        }
        return (React.createElement("div", { onClick: this.onOverlayClick, className: css(styles.overlay) },
            React.createElement("div", { className: css(styles.mask) }),
            React.createElement("div", { className: css(styles.wrapper) },
                this.props.vm.isShowStepButtons || !this.props.vm.isFirstLesson ? (React.createElement("div", { onClick: this.props.vm.isShowStepButtons ? this.onRewindClick : this.onPrevClick, className: css(styles.button) },
                    React.createElement("img", { src: `/assets/images/video/${this.props.vm.isShowStepButtons ? 'rewind' : 'prev'}.svg`, className: css(styles.skipButtonImage) }))) : (React.createElement("div", { className: css(styles.emptyButton) })),
                React.createElement("div", { onClick: this.isPaused ? this.onPlayClick : this.onPauseClick, className: css(styles.button) },
                    React.createElement("img", { src: `/assets/images/video/${this.isPaused ? 'play' : 'pause'}.svg`, className: css(styles.playButtonImage) })),
                this.props.vm.isShowStepButtons || !this.props.vm.isLastLesson ? (React.createElement("div", { onClick: this.props.vm.isShowStepButtons ? this.onForwardClick : this.onNextClick, className: css(styles.button) },
                    React.createElement("img", { src: `/assets/images/video/${this.props.vm.isShowStepButtons ? 'forward' : 'next'}.svg`, className: css(styles.skipButtonImage) }))) : (React.createElement("div", { className: css(styles.emptyButton) })))));
    }
}
__decorate([
    bind
], VideoControllerComponent.prototype, "handleSeekedEvent", null);
__decorate([
    bind
], VideoControllerComponent.prototype, "onPlayClick", null);
__decorate([
    bind
], VideoControllerComponent.prototype, "onPauseClick", null);
__decorate([
    bind
], VideoControllerComponent.prototype, "onRewindClick", null);
__decorate([
    bind
], VideoControllerComponent.prototype, "onForwardClick", null);
__decorate([
    bind
], VideoControllerComponent.prototype, "onPrevClick", null);
__decorate([
    bind
], VideoControllerComponent.prototype, "onNextClick", null);
__decorate([
    bind
], VideoControllerComponent.prototype, "onOverlayClick", null);
__decorate([
    bind
], VideoControllerComponent.prototype, "setHideTimer", null);
__decorate([
    bind
], VideoControllerComponent.prototype, "clearHideTimer", null);
__decorate([
    bind
], VideoControllerComponent.prototype, "show", null);
__decorate([
    bind
], VideoControllerComponent.prototype, "hide", null);
class VjsVideoControllerVM {
    constructor() {
        Object.defineProperty(this, "isFullScreen", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isFirstLesson", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isLastLesson", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isAlwaysShowStepButtons", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isShowStepButtons", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        makeObservable(this, {
            isFullScreen: observable,
            isFirstLesson: observable,
            isLastLesson: observable,
            isAlwaysShowStepButtons: observable,
            isShowStepButtons: observable,
        });
    }
    setIsFullScreen(isFullScreen) {
        this.isFullScreen = isFullScreen;
        if (!this.isAlwaysShowStepButtons) {
            this.isShowStepButtons = isFullScreen;
        }
    }
    setIsFirstLesson(isFirstLesson) {
        this.isFirstLesson = isFirstLesson;
    }
    setIsLastLesson(isLastLesson) {
        this.isLastLesson = isLastLesson;
    }
    setShowStepButtons(showStepButtons) {
        this.isAlwaysShowStepButtons = showStepButtons;
    }
    setIsShowStepButtons(isShowStepButtons) {
        this.isShowStepButtons = isShowStepButtons;
    }
}
__decorate([
    bind
], VjsVideoControllerVM.prototype, "setIsFullScreen", null);
__decorate([
    bind
], VjsVideoControllerVM.prototype, "setIsFirstLesson", null);
__decorate([
    bind
], VjsVideoControllerVM.prototype, "setIsLastLesson", null);
__decorate([
    bind
], VjsVideoControllerVM.prototype, "setShowStepButtons", null);
__decorate([
    bind
], VjsVideoControllerVM.prototype, "setIsShowStepButtons", null);
const VideoController = observer(VideoControllerComponent);
export default class VjsVideoController extends videojs.getComponent('Component') {
    constructor(player, options) {
        super(player, options);
        Object.defineProperty(this, "videoControllerOptions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "videoControllerPlayer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "ref", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: React.createRef()
        });
        Object.defineProperty(this, "vm", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        this.videoControllerOptions = options;
        this.videoControllerPlayer = player;
        this.vm = new VjsVideoControllerVM();
        this.vm.setIsFirstLesson(options.isFirstLesson);
        this.vm.setIsLastLesson(options.isLastLesson);
        this.vm.setShowStepButtons(options.isAlwaysShowStepButtons);
        this.vm.setIsShowStepButtons(options.isAlwaysShowStepButtons);
        this.mount = this.mount.bind(this);
        this.videoControllerPlayer.ready(() => {
            this.mount();
        });
    }
    seek(secs) {
        let time = this.videoControllerPlayer.currentTime() + secs;
        if (time < 0) {
            time = 0;
        }
        this.videoControllerPlayer.currentTime(time);
    }
    forward() {
        this.seek(10);
    }
    rewind() {
        this.seek(-10);
    }
    prev() {
        this.videoControllerOptions.onClickPrev();
    }
    next() {
        this.videoControllerOptions.onClickNext();
    }
    play() {
        this.videoControllerPlayer.play();
    }
    pause() {
        this.videoControllerPlayer.pause();
    }
    paused() {
        return this.videoControllerPlayer.paused();
    }
    showProgressBar() {
        const controlBar = this.getProgressBar();
        controlBar === null || controlBar === void 0 ? void 0 : controlBar.trigger('showProgressBar');
    }
    hideProgressBar() {
        const controlBar = this.getProgressBar();
        controlBar === null || controlBar === void 0 ? void 0 : controlBar.trigger('hideProgressBar');
    }
    getProgressBar() {
        if (this.videoControllerPlayer.isDisposed())
            return null;
        return this.videoControllerPlayer.getChild('ControlBar');
    }
    // HACK: iOS Safari でフルスクリーンの解除をした場合に呼び出される
    setIsPaused(paused) {
        var _a;
        (_a = this.ref.current) === null || _a === void 0 ? void 0 : _a.setIsPaused(paused);
    }
    setHideTimer() {
        var _a;
        (_a = this.ref.current) === null || _a === void 0 ? void 0 : _a.setHideTimer();
    }
    show() {
        var _a;
        (_a = this.ref.current) === null || _a === void 0 ? void 0 : _a.show();
    }
    hide() {
        var _a;
        (_a = this.ref.current) === null || _a === void 0 ? void 0 : _a.hide();
    }
    mount() {
        const root = ReactDOM.createRoot(this.el());
        root.render(React.createElement(VideoController, { vm: this.vm, ref: this.ref, play: this.play, pause: this.pause, rewind: this.rewind, forward: this.forward, prev: this.prev, next: this.next, showProgressBar: this.showProgressBar, hideProgressBar: this.hideProgressBar }));
    }
}
__decorate([
    bind
], VjsVideoController.prototype, "seek", null);
__decorate([
    bind
], VjsVideoController.prototype, "forward", null);
__decorate([
    bind
], VjsVideoController.prototype, "rewind", null);
__decorate([
    bind
], VjsVideoController.prototype, "prev", null);
__decorate([
    bind
], VjsVideoController.prototype, "next", null);
__decorate([
    bind
], VjsVideoController.prototype, "play", null);
__decorate([
    bind
], VjsVideoController.prototype, "pause", null);
__decorate([
    bind
], VjsVideoController.prototype, "paused", null);
__decorate([
    bind
], VjsVideoController.prototype, "showProgressBar", null);
__decorate([
    bind
], VjsVideoController.prototype, "hideProgressBar", null);
__decorate([
    bind
], VjsVideoController.prototype, "setIsPaused", null);
__decorate([
    bind
], VjsVideoController.prototype, "setHideTimer", null);
__decorate([
    bind
], VjsVideoController.prototype, "show", null);
__decorate([
    bind
], VjsVideoController.prototype, "hide", null);
const styles = StyleSheet.create({
    wrapper: {
        position: 'absolute',
        left: 0,
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        gap: 48,
        [MediaBreakPointUp.MD]: {
            gap: 68,
        },
    },
    overlay: {
        position: 'absolute',
        top: '0',
        right: '0',
        bottom: '0',
        left: '0',
        zIndex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        lineHeight: 1,
    },
    mask: {
        position: 'absolute',
        top: '0',
        right: '0',
        bottom: '0',
        left: '0',
        background: '#000',
        opacity: 0.4,
        pointerEvents: 'auto',
    },
    button: {
        userSelect: 'none',
        outline: 'none',
        cursor: 'pointer',
        transform: 'scale(1)',
        transition: 'transform 160ms ease-out',
        '@media (hover: hover)': {
            ':hover': {
                transform: 'scale(1.2)',
            },
        },
        ':active': {
            transform: 'scale(0.8)',
        },
    },
    emptyButton: {
        width: 60,
    },
    playButtonImage: {
        width: 48,
        [MediaBreakPointUp.MD]: {
            width: 68,
        },
    },
    skipButtonImage: {
        width: 40,
        [MediaBreakPointUp.MD]: {
            width: 60,
        },
    },
});
